import {
  arbitrum,
  arbitrumGoerli,
  mainnet,
  polygon,
  polygonMumbai,
  optimism,
  optimismGoerli,
  sepolia,
  ronin,
  saigon,
  aurora,
  avalanche,
  base,
  bsc,
  celo,
  gnosis,
  ink,
  inkSepolia,
  zkSync,
  zora,
} from './chains'

export const constants = {
  chains: [
    arbitrum,
    arbitrumGoerli,
    mainnet,
    polygon,
    polygonMumbai,
    optimism,
    optimismGoerli,
    sepolia,
    ronin,
    saigon,
    aurora,
    avalanche,
    base,
    bsc,
    celo,
    gnosis,
    ink,
    inkSepolia,
    zkSync,
    zora,
  ],
  // @ts-ignore
  PROJECT_ID: WALLET_CONNECT_PROJECT_ID,
  METADATA: {
    name: 'Remix IDE',
    description: 'The Native IDE for Web3 Development.',
    url: 'https://remix.ethereum.org/',
    icons: ['https://remix.ethereum.org/favicon.ico'],
  }
}
